// src/components/activity-category/activity-category.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment ActivityCategoryCardDetailFragment on ActivityBasicTile {\n    name\n    clickAction {\n      accessibilityText\n    }\n    link\n    image {\n      description\n      url\n    }\n    analytics {\n      linkName\n      referrerId\n    }\n    secondaryMessage\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  query ActivityCategoryQuery($context: ContextInput!, $dateRange: ActivityDateRangeInput, $destination: ActivityDestinationInput) {\n    activityModules(context: $context, dateRange: $dateRange, destination: $destination) {\n      categories {\n        activityTiles {\n          ...ActivityCategoryCardDetailFragment\n        }\n        navigationActions {\n          previous {\n            accessibility\n          }\n          next {\n            accessibility\n          }\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
import React2 from "react";
import { gql as gql2, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { UitkCarousel } from "uitk-react-carousel";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkHeading } from "uitk-react-text";
// src/components/activity-category/__private/__fragments/activity-category-card-detail.tsx
import React from "react";
import { gql } from "@apollo/client";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkCard, UitkCardLink } from "uitk-react-cards";
import { UitkFigure, UitkFigureAspectRatioType } from "uitk-react-images";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkScrim, UitkScrimType } from "uitk-react-scrim";
import { UitkText } from "uitk-react-text";
var fragment = gql(_templateObject());
var ActivityCategoryCardDetail = function(param) {
    var data = param.data;
    var _data_image, _data_clickAction;
    var track = useClickTracker();
    var handleClick = React.useCallback(function() {
        if (data.analytics) {
            track(data.analytics.referrerId, data.analytics.linkName);
        }
    }, [
        track,
        data.analytics
    ]);
    return /* @__PURE__ */ React.createElement(UitkLayoutGrid, null, /* @__PURE__ */ React.createElement(UitkLayoutGridItem, null, /* @__PURE__ */ React.createElement(UitkCard, {
        "data-stid": "activity-category",
        border: true
    }, /* @__PURE__ */ React.createElement(UitkFigure, {
        ratio: UitkFigureAspectRatioType.R3_4,
        src: (_data_image = data.image) === null || _data_image === void 0 ? void 0 : _data_image.url
    }, /* @__PURE__ */ React.createElement(UitkScrim, {
        type: UitkScrimType.BOTTOM
    }, /* @__PURE__ */ React.createElement(UitkText, {
        weight: "bold",
        align: "center",
        size: 300
    }, data.name))), /* @__PURE__ */ React.createElement(UitkCardLink, null, /* @__PURE__ */ React.createElement("a", {
        href: data.link || "",
        target: data.link ? "_blank" : "_self",
        rel: "noopener noreferrer",
        "data-stid": data.name,
        onClick: handleClick
    }, data.name, ((_data_clickAction = data.clickAction) === null || _data_clickAction === void 0 ? void 0 : _data_clickAction.accessibilityText) && /* @__PURE__ */ React.createElement("span", {
        className: "is-visually-hidden"
    }, data.clickAction.accessibilityText))))));
};
ActivityCategoryCardDetail.fragment = fragment;
ActivityCategoryCardDetail.displayName = "ActivityCategoryCardDetail";
// src/components/activity-category/activity-category.tsx
var __Query = gql2(_templateObject1(), ActivityCategoryCardDetail.fragment);
var ActivityCategory = function(props) {
    var _activityTiles, _navigationActions, _navigationActions1;
    var inputs = props.inputs, skipSsr = props.skipSsr, title = props.title;
    var context = useBexApi().context;
    var variables = _object_spread_props(_object_spread({}, inputs || {}), {
        context: context
    });
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    if (error || loading || !data) {
        return null;
    }
    var _ref = data.activityModules.categories || {}, activityTiles = _ref.activityTiles, navigationActions = _ref.navigationActions;
    if (!((_activityTiles = activityTiles) === null || _activityTiles === void 0 ? void 0 : _activityTiles.length)) {
        return null;
    }
    var _navigationActions_next_accessibility, _navigationActions_previous_accessibility;
    return /* @__PURE__ */ React2.createElement(React2.Fragment, null, /* @__PURE__ */ React2.createElement(UitkSpacing, {
        margin: {
            block: "four"
        }
    }, /* @__PURE__ */ React2.createElement(UitkHeading, {
        tag: "h2",
        size: 4
    }, title)), /* @__PURE__ */ React2.createElement(UitkCarousel, {
        buttonText: {
            nextButton: (_navigationActions_next_accessibility = (_navigationActions = navigationActions) === null || _navigationActions === void 0 ? void 0 : _navigationActions.next.accessibility) !== null && _navigationActions_next_accessibility !== void 0 ? _navigationActions_next_accessibility : "",
            prevButton: (_navigationActions_previous_accessibility = (_navigationActions1 = navigationActions) === null || _navigationActions1 === void 0 ? void 0 : _navigationActions1.previous.accessibility) !== null && _navigationActions_previous_accessibility !== void 0 ? _navigationActions_previous_accessibility : ""
        },
        pageBy: 1,
        peek: true,
        itemsVisible: {
            lg: 6,
            md: 5,
            sm: 3
        }
    }, activityTiles.map(function(category, index) {
        return category.__typename === "ActivityBasicTile" && /* @__PURE__ */ React2.createElement(ActivityCategoryCardDetail, {
            data: category,
            key: "category-".concat(index)
        });
    })));
};
ActivityCategory.displayName = "sharedui-ActivityCategory";
export { ActivityCategory };
//# sourceMappingURL=index.js.map